<template>
  <v-container
    class="d-flex flex-column align-center justify-center text-center"
    style="border: 0.5px solid grey; border-radius: 8px; height: 430px; width: 600px"
  >
    <v-icon class="mb-2" color="success" size="70">check_circle</v-icon>
    <h4 class="mb-3">Sua solicitação foi registrada com sucesso!</h4>
    <v-divider class="mb-3 " style="width: 400px"></v-divider>
    <div class="d-flex flex-column pa-5" style="gap: 4px; width: 100%">
      <strong class="text-start font-weight-semibold">
        Número do protocolo: {{ response.numeroProtocolo }}
      </strong>
      <strong class="text-start font-weight-semibold"
        >Token de acesso: {{ response.token }}
      </strong>
      <strong class="text-start font-weight-semibold"
        >Data de criação: {{ response.dataCriacao }}
      </strong>
    </div>
    <p class="text-justify" style="width: 550px">
      Você pode acompanhar a análise em nossa Central de Serviços, no menu
      <strong>Gás Canalizado > Consulta de Solicitação</strong>, utilizando o número do protocolo e
      token enviado por e-mail.
    </p>
    <v-btn color="primary" @click="voltarParaHome"> Voltar para a página inicial </v-btn>
  </v-container>
</template>
<script>
export default {
  name: 'StepFinalizacao',
  props: {
    response: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    voltarParaHome() {
      this.$emit('limparForm');
      this.$emit('voltarStep1');
    },
  },
};
</script>
